module.exports = __webpack_public_path__ + "static/media/plexusLoader3.84d84b26.gif";